export enum TStatusDotIcon {
  Blank,
  Red,
  Golden,
  Blue,
  Yellow,
  Green,
  Orange,
}

export interface IStatusDotProps {
  className?: string;
  icon: TStatusDotIcon;
  title: string;
  small?: boolean;
}
